'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var checkIsUserLoggedIn = function checkIsUserLoggedIn() {
  return /icook_user_id=/.test(document.cookie);
};

var isFacebookApp = function isFacebookApp() {
  return /FBA[N|V]/g.test(navigator.userAgent);
};

var isMobile = function isMobile() {
  return /Mobi/.test(navigator.userAgent);
};

var isIOS = function isIOS() {
  return /iP(od|ad|hone)/i.test(navigator.userAgent);
};

var isHybrid = function isHybrid() {
  return /icook/i.test(navigator.userAgent);
};

var isClient = function isClient() {
  return typeof window !== 'undefined' && window.document;
};

var getOriginByURL = function getOriginByURL(URL) {
  if (/^https:\/\/icook.(tw|dev)\/products/.test(URL)) {
    return 'icook_proudct';
  }

  if (/^https:\/\/icook.(tw|dev)/.test(URL)) {
    return 'icook';
  }

  if (/^https:\/\/market.icook.(tw|dev)/.test(URL)) {
    return 'market';
  }

  if (/^https:\/\/blog.icook.(tw|dev)/.test(URL)) {
    return 'blog';
  }

  if (/^https:\/\/tv.icook.(tw|dev)/.test(URL)) {
    return 'tv';
  }

  return 'icook';
};

var getUrlParameter = function getUrlParameter(name) {
  var key = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(key, "=([^&#]*)"));
  var results = regex.exec(window.location.href);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

var getLocationOrigin = function getLocationOrigin() {
  return "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(window.window.location.port ? ":".concat(window.location.port) : '');
};

var getIcookOrigin = function getIcookOrigin() {
  return getLocationOrigin().replace(/((?!\/\/)[\w\d]+\.(?=icook))/, '');
};

var deviseSignIn = function deviseSignIn() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parameters = [];
  Object.keys(option).forEach(function (key) {
    parameters.push("".concat(key, "=").concat(encodeURIComponent(option[key])));
  });
  var queryString = parameters.length ? "?".concat(parameters.join('&')) : '';
  var signInURL = "".concat(getIcookOrigin(), "/login");
  window.location.assign("".concat(signInURL).concat(queryString));
};

var deviseSignUp = function deviseSignUp(redirectURL) {
  var signUpURL = "".concat(getIcookOrigin(), "/signup");
  window.location.assign("".concat(signUpURL, "?redirect=").concat(encodeURIComponent(redirectURL)));
};

var deviseLogout = function deviseLogout(redirectURL) {
  var logoutURL = "".concat(getIcookOrigin(), "/logout");

  if (/^https:\/\/icook.(tw|dev)\/users\/.+\/favorites/.test(redirectURL) || /^https:\/\/icook.(tw|dev)\/users\/.+\/followings/.test(redirectURL) || /^https:\/\/icook.(tw|dev)\/settings/.test(redirectURL) || /^https:\/\/icook.(tw|dev)\/recipes\/new/.test(redirectURL) || /^https:\/\/icook.(tw|dev)\/vip$/.test(redirectURL)) {
    window.location.assign("".concat(logoutURL, "?redirect=").concat(encodeURIComponent('https://icook.tw')));
  } else if (/^https:\/\/icook.(tw|dev)\/campaigns/.test(redirectURL)) {
    window.location.assign("".concat(logoutURL, "?redirect=").concat(encodeURIComponent('https://icook.tw/campaigns')));
  } else if (/^https:\/\/market.icook.(tw|dev)\/users\/favorites/.test(redirectURL) || /^https:\/\/market.icook.(tw|dev)\/orders\/new/.test(redirectURL) || /^https:\/\/market.icook.(tw|dev)\/orders/.test(redirectURL)) {
    window.location.assign("".concat(logoutURL, "?redirect=").concat(encodeURIComponent('https://market.icook.tw')));
  } else {
    window.location.assign("".concat(logoutURL, "?redirect=").concat(encodeURIComponent(redirectURL)));
  }
};

var continueAfterLogin = function continueAfterLogin(key) {
  if (checkIsUserLoggedIn() && getUrlParameter('continueAfterLogin') === key) {
    window.history.replaceState(null, '', window.location.pathname);
    return true;
  }

  return false;
};

exports.checkIsUserLoggedIn = checkIsUserLoggedIn;
exports.continueAfterLogin = continueAfterLogin;
exports.deviseLogout = deviseLogout;
exports.deviseSignIn = deviseSignIn;
exports.deviseSignUp = deviseSignUp;
exports.getOriginByURL = getOriginByURL;
exports.getUrlParameter = getUrlParameter;
exports.isClient = isClient;
exports.isFacebookApp = isFacebookApp;
exports.isHybrid = isHybrid;
exports.isIOS = isIOS;
exports.isMobile = isMobile;
